import React from "react";
import { useParams } from "react-router";
import { RefActivity } from "../../../api/hooks";
import ActivityView from "../../../common/activity/ActivityView";

const PaymentMethodActivity = () => {
    const { paymentId } = useParams<any>();
    return (
        <div>
            {paymentId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.PaymentConfiguration}
                    activityRefId={paymentId ?? ""}
                />
            )}
        </div>
    );
};

export default PaymentMethodActivity;
